'use client'

import React, { useEffect } from 'react'
import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'

import { browserIdState } from '@/components/Context/BrowserProvider'
import { getLoginSession } from '@/serverActions/getLoginSession'
import { UserType } from '@/types/user'

export const jwtTokenState = atom<boolean>({
  key: 'jwtToken',
  default: false,
})

export const loginUserState = atom<UserType | null>({
  key: 'loginUser',
  default: null,
})

export default function JwtProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Login />
      {children}
    </>
  )
}

const Login = () => {
  const browserId = useRecoilValue(browserIdState)
  const [loginSession, setLoginSession] = useRecoilState(jwtTokenState)
  const setLoginUser = useSetRecoilState(loginUserState)
  useEffect(() => {
    ;(async () => {
      if (loginSession || browserId == null) return

      const response = await getLoginSession()
      if (response == null || !response.success) return
      setLoginSession(true)
      setLoginUser(response.loginSession.user)
    })()
  }, [browserId])
  return <></>
}
